import { render, staticRenderFns } from "./NewArchiveModal.vue?vue&type=template&id=ca315f64&scoped=true"
import script from "./NewArchiveModal.vue?vue&type=script&lang=js"
export * from "./NewArchiveModal.vue?vue&type=script&lang=js"
import style0 from "./NewArchiveModal.vue?vue&type=style&index=0&id=ca315f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca315f64",
  null
  
)

export default component.exports